(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .controller("ChangeDeviceLabelNameController", ChangeDeviceLabelNameController);

  /** @ngInject */
  function ChangeDeviceLabelNameController($scope, $mdDialog, data) {
    var vm = this;

    init();

    vm.actuate = function () {
      $mdDialog.hide({
        pointId: data.pointId,
        label: vm.labelToEdit
      });
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    function init() {
      $scope.$on("$destroy", destroy);
      vm.data = data;
      vm.labelToEdit = data.deviceLabel;
    }

    function destroy() {}
  }
})();
